import React, { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ChevronDown } from "lucide-react";

const FAQ = [
  {
    q: "Quels sont les prérequis pour candidater ?",
    a: "À chaque profil sa voie :\n• Bachelor — Bac validé\n• Master — Bac+3, (les filières spécialités disponibles)\n• Executive MBA — Bac+5 et au moins 5 ans d'expérience\nNotre conviction : votre motivation et votre projet professionnel comptent tout autant que votre dossier académique.",
  },
  {
    q: "Quel est le coût des formations ?",
    a: "Des frais de scolarité adaptés à chaque profil, pour vous accompagner : contactez-nous pour établir votre devis personnalisé.",
  },
  {
    q: "Le diplôme est-il celui de l'ECL France ?",
    a: "Oui, rien ne change sauf le lieu. Mêmes programmes, mêmes diplômes, même reconnaissance internationale.",
  },
  {
    q: "Les cours sont-ils en français ou en anglais ?",
    a: "Les formations est majoritairement en français, mais intègre des modules en anglais pour développer votre agilité linguistique et votre compétitivité sur le marché global.",
  },
  {
    q: "Quels sont les délais de candidature ?",
    a: "Les candidatures sont ouvertes en continu, mais nous recommandons de postuler 1 mois avant la rentrée.",
  },
];

const FaqItem = ({ f, index }) => {
  const [open, setOpen] = useState(false);
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: index * 0.07 }}
      className="border-b border-navy-100 last:border-0"
    >
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-start justify-between gap-4 py-5 text-left group"
      >
        <span className={`font-display text-lg md:text-xl transition-colors ${open ? "text-red-500" : "text-navy-700 group-hover:text-navy-500"}`}>
          {f.q}
        </span>
        <ChevronDown className={`h-5 w-5 shrink-0 mt-1 transition-all duration-300 ${open ? "rotate-180 text-red-500" : "text-navy-400"}`} />
      </button>
      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          transition={{ duration: 0.3 }}
          className="pb-5"
        >
          {f.a.split("\n").map((line, j) => (
            <span key={j} className="block text-[15px] text-[#555] leading-relaxed">{line}</span>
          ))}
        </motion.div>
      )}
    </motion.div>
  );
};

export const AdmissionsFaq = () => {
  const navigate = useNavigate();

  return (
    <section className="section-padding bg-white" data-testid="admissions-faq-section">
      <div className="container-edge">
        <div className="grid grid-cols-12 gap-10 lg:gap-16">
          <div className="col-span-12 lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <div className="overline mb-4">FAQ</div>
              <h2 className="font-display text-2xl sm:text-3xl md:text-4xl text-navy-700 mb-5">
                Questions fréquentes
              </h2>
              <p className="text-[#555] text-[15px] leading-relaxed mb-8">
                Une question ? Notre équipe admissions est disponible pour vous répondre personnellement.
              </p>
              <button onClick={() => navigate("/contact")} className="btn-outline-navy">
                Nous contacter
                <ArrowRight className="h-4 w-4" />
              </button>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-8" data-testid="admissions-faq">
            {FAQ.map((f, i) => <FaqItem key={i} f={f} index={i} />)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdmissionsFaq;
